type MarketRegisterErrorMessageParams = {
  code: string;
  message: string;
  marketNameEnglish: string;
};

const ID_PASSWORD_MISMATCH_MESSAGE = '아이디 또는 비밀번호가 일치하지 않습니다.';

export const getMarketRegisterErrorMessage = ({
  code,
  message,
  marketNameEnglish,
}: MarketRegisterErrorMessageParams) => {
  if (code === '610' && marketNameEnglish !== 'toss') {
    return ID_PASSWORD_MISMATCH_MESSAGE;
  }

  return message;
};
